import { render, staticRenderFns } from "./NotesActivity.vue?vue&type=template&id=0db724ab&scoped=true"
import script from "./NotesActivity.vue?vue&type=script&lang=js"
export * from "./NotesActivity.vue?vue&type=script&lang=js"
import style0 from "./NotesActivity.vue?vue&type=style&index=0&id=0db724ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db724ab",
  null
  
)

export default component.exports